export default "__VITE_ASSET__DxG4JEye__"